import { company } from '@/data/company';
import { MotionReveal } from '@/components/common/MotionReveal';
import { SectionTitle } from '@/components/common/SectionTitle';

export function MapSection() {
  return (
    <section className="border-t border-border bg-surface-muted py-18 sm:py-24 lg:py-28">
      <div className="site-container grid gap-9 lg:grid-cols-[0.38fr_0.62fr] lg:items-start lg:gap-16">
        <SectionTitle
          eyebrow="Lokacija"
          title="Posetite nas u Beogradu."
          description="Za sastanak uživo preporučujemo da unapred dogovorimo termin."
        />
        <MotionReveal>
          <iframe
            className="h-[360px] w-full rounded-[var(--radius-sm)] border-0 sm:h-[440px]"
            src={company.mapEmbedUrl}
            title="Google mapa lokacije kompanije Helmflex"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </MotionReveal>
      </div>
    </section>
  );
}

